<template>
  <NuxtLayout
    name="generic"
    header="standardWhite"
    footer="standard"
  >
    <div v-if="data">
      <CaseStudiesHero :data="data.caseStudyHero" />

      <CaseStudiesContent :data="data.caseStudyContent" />

      <CTABanner
        v-if="data.CTABanner?.reference"
        :data="data.CTABanner.reference"
      />

      <SuggestedContent v-if="!data.removeSuggestedContent" />
    </div>
  </NuxtLayout>
</template>

<script lang="ts" setup>
import { queryCaseStudy } from '~/queries/pages/PageCaseStudy.query';
import type { QueryCaseStudyResult } from '~/sanity/types';

const { path: currentPathname } = useRoute();

const { data } = await useWwwSanityQuery<QueryCaseStudyResult>(queryCaseStudy, {
  currentPathname,
});

usePageHead({
  _id: data.value?._id,
  description: data.value?.ogDescription || data.value?.description,
  ogImage: data.value?.ogImage ?? data.value?.heroImage,
  excludeFromExternalSearch: data.value?.excludeFromExternalSearch,
  title: data.value?.htmlTitle || data.value?.title,
  twitterCard: 'summary',
});
</script>
